let pics = [
  new URL("../assets/memoriestabphotodump/IMG_5602.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_5604.jpeg", import.meta.url),

  new URL("../assets/featherfeautre.jpg", import.meta.url),
  new URL(
    "../assets/memoriestabphotodump/0D332444-5C87-42F4-B5CA-A7AA7CFAD58F.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/0e121a9c-5ae8-41ea-9912-859450ea0a67.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/0EE41B55-8140-4393-A3C0-EBF3E078D148.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/0ef3686c-af5c-4a28-844c-36cf07440113.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/0F510795-04CD-44A5-B0B0-0AF58E678195.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/086a2df1-ab0b-4716-b30b-6e85673e5525.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/2a12fc93-8db8-411b-8a11-fa4486e73ec6.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/2ae15c9e-e5bc-4e09-baea-d267342529d2.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/2F8E6853-2497-4709-87FA-C5D015739FBF.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/3b649a1b-d722-4570-87c4-76eda0f6ea01.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/3cb8a7ee-1528-4533-a03d-4591e22cdd60.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/3ff14fde-2d90-439e-bb86-86709bd87278.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/4BDFDBF9-B48C-4349-A508-3A85DA0427CF.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/6d65a088-04ac-4ced-a8d7-aaba188789cc.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/14b87429-9ed4-494e-a3aa-79b52ffa12dd.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/71a5b125-2760-4baa-93aa-8dcc58795a67.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/296a97f3-da3a-45ae-abf7-df93e6a43ad6.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/962fdbf1-85e4-49c4-bcf4-8d8e0c8f4e3f.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/6463ae67-e104-4c94-8157-3a5585c8d00b.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/9622f86f-c3bf-480d-ac8b-0b63b866fa66.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/321111d8-05c7-4085-bed0-e03c7d3e0413.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/1674626c-58c0-4c0b-8ef9-67421eb93ffd.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/997554732305667332.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/2516426713522933014.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/3929062271793101592.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/4889895707960879218.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/6782551657763913384.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/A200DD6A-1F72-477F-AF3F-E0012057C2E9.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/a86494d9-ff12-4165-9cf3-fbff101f1cb7.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/b3b4b64c-4e75-48c4-ba92-e9fc8fb2aab1.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/b6a500f0-b625-4152-8efd-210d630283e4.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/dabac9a5-734d-410e-9cf3-1cee99d65d4a.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/e7ef49a5-724d-4c60-ad45-b0395eb11d41.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/eca7d628-e7ee-4c4a-8b45-d6331fc1aeee.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/f0b7ed0d-62ff-4c20-af34-19b83d298cea.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/F2B92435-400B-4F23-BC94-92EDAB9AAA17.jpeg",
    import.meta.url,
  ),
  new URL(
    "../assets/memoriestabphotodump/ff4b264b-e692-4d01-a249-21d919db9f87.jpeg",
    import.meta.url,
  ),
  new URL("../assets/memoriestabphotodump/IMG_0494.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_2499.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_3346.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_3571.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_3636.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_4930.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_4954.jpeg", import.meta.url),
  new URL("../assets/memoriestabphotodump/IMG_7431.jpeg", import.meta.url),
];
export default pics;
